module.exports = __webpack_public_path__ + "static/TiltBanana-768b1529bb9d58b766218b2767d86c97.jpg";